import { mount } from '../dom-lifecycle';

const messages = {
	empty: () => `Załącz plik`,
	size: (rules) => `Maksymalny rozmiar pliku to ${rules.size} MB`,
	type: (rules) => `Nieprawidłowy format`,
};

const validate = (file, rules) => {
	const errors = [];
	if (file.size > rules.size * 1024 * 1024) {
		errors.push("size");
	}
	if (rules.type && !rules.type.includes(file.name.split('.').pop().toLowerCase())) {
		errors.push("type");
	}
	return errors;
};

mount(".form-file", root => {
	const input = root.querySelector("input[type=file]");
	const box = root.querySelector(".form-file-box");
	const badge = root.querySelector(".form-file-badge");
	const rules = {
		size: $(input).data("max-size"),
		type: $(input).attr("accept"),
	};

	if (rules.type) {
		root.querySelector(".file-type").textContent = rules.type
			.split(",")
			.map(type => type.trim().replace(".", ""))
			.join(", ");
	}
	if (rules.size) {
		root.querySelector(".file-size").textContent = `${rules.size} MB`;
	}

	// Komunikat o braku pliku przychodzi z serwera (invalid_feedback), a komunikaty
	// o rozmiarze/formacie podmieniają go na czas błędu — trzymamy go, żeby móc wrócić.
	const emptyMessage = badge.textContent.trim() || messages.empty();

	const showError = message => {
		badge.textContent = message;
		root.classList.add("has-error");
	};

	const reset = () => {
		root.classList.remove("has-file", "has-error");
		root.querySelector(".file-name").textContent = "";
		badge.textContent = emptyMessage;
	};

	input.addEventListener("change", () => {
		reset();
		const file = input.files[0];
		if (!file) {
			showError(emptyMessage);
			return;
		}
		const errors = validate(file, rules);
		if (errors.length) {
			input.value = "";
			showError(errors.map(error => messages[error](rules)).join(" "));
			return;
		}
		root.querySelector(".file-name").textContent = file.name;
		root.classList.add("has-file");
	});

	["dragenter", "dragover"].forEach(type => box.addEventListener(type, event => {
		event.preventDefault();
		root.classList.add("is-dragover");
	}));
	["dragleave", "drop"].forEach(type => box.addEventListener(type, event => {
		event.preventDefault();
		root.classList.remove("is-dragover");
	}));
	box.addEventListener("drop", event => {
		if (event.dataTransfer.files.length) {
			input.files = event.dataTransfer.files;
			input.dispatchEvent(new Event("change"));
		}
	});

	input.form.addEventListener("reset", reset);
});
